import types from './mutation-types';

export default {
  [types.SET_CURRENT_OPEN_MENU](state, playLoad) {
    state.currentOpenMenu = playLoad;
  },
  [types.SET_CURRENT_MENU](state, playLoad) {
    state.currentMenu = playLoad;
  },
  [types.TOGGLE_SIDE_NAV](state) {
    state.showSideNav = !state.showSideNav;
  },
  [types.CURRENT_PROJECT_ID](state, playLoad) {
    state.currentProjectId = playLoad;
  },
  [types.USER_INFO](state, playLoad) {
    state.userInfo = playLoad;
  },
  [types.AUTH_URL_LIST](state, playLoad) {
    state.authUrlList = playLoad;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js